import { useState } from 'react'
import HeaderControls from '@src/Pages/SettingsPage/ManageUsers/HeaderControls'
import UsersTable from '@src/Pages/SettingsPage/ManageUsers/UsersTable'
import { useGetUsersQuery } from '@wove/api'
import { Card, CardTitle, CardHeader, CardDescription, CardContent } from '@wove/web-ui'
import { Users } from 'lucide-react'

const ManageUsers = () => {
  const [usersData] = useGetUsersQuery()
  const [searchText, setSearchText] = useState('')
  return (
    <div className="flex flex-col gap-6 p-6">
      <Card>
        <CardHeader className="flex flex-row items-center justify-between">
          <div>
            <CardTitle className="text-2xl">Team Management</CardTitle>
            <CardDescription>Manage your team members and their permissions</CardDescription>
          </div>
          <Users className="h-5 w-5 text-muted-foreground" />
        </CardHeader>
        <CardContent className="space-y-6">
          <div className="flex justify-between items-center">
            <h3 className="text-lg font-medium">
              Team Members {usersData?.data ? ` (${usersData.data.getUsers.users.length})` : ''}
            </h3>
          </div>
          <div className="mb-2">
            <HeaderControls searchText={searchText} setSearchText={setSearchText} />
          </div>
          {usersData?.data && (
            <UsersTable
              //@ts-expect-error types are not matching for some reason
              users={usersData.data.getUsers.users.filter((user) => {
                const name = `${user.firstName} ${user.lastName}`
                return name.includes(searchText) || user.email.includes(searchText)
              })}
            />
          )}
        </CardContent>
      </Card>
    </div>
  )
}

export default ManageUsers
